module.exports = __webpack_public_path__ + "static/problemy-f0ba91750f7404b00378a5261ef6aa44.jpeg";